import React from 'react'
import wireImage1 from '../../img/compoundwirecutter/wirecutter-1.png';
import wireImage2 from '../../img/compoundwirecutter/wirecutter-nasa.png';
import wireImage3 from '../../img/compoundwirecutter/wirecutter-empty.png';
import wireVideo from '../../img/compoundwirecutter/compoundwirecutter-video.avi';
const CompountWireCutter = () => {
    return (
        <div className='compount-wire-cutter-container text-center text-white py-3'>
            <div className="compund-main">
                <h1 className='text-white py-2'>Compound Wire Cutter</h1>
                <div id="carouselExampleControls" class="carousel slide py-3" data-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img className='d-block w-100' src={wireImage1} alt="First Image Project" />
                        </div>
                        <div class="carousel-item ">
                            <img className='d-block w-100' src={wireImage2} alt="First Image Project" />
                        </div>
                        <div class="carousel-item ">
                            <img className='d-block w-100' src={wireImage3} alt="First Image Project" />
                        </div>

                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                <h2 className="text-white py-3">To Lessen The Effort</h2>
            </div>
            <iframe className='embeded-frame py-3' src="https://myhub.autodesk360.com/ue2a4d27f/shares/public/SH919a0QTf3c32634dcf00586272656828d5?mode=embed" width="900" height="700" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0"></iframe>
            <div className="project-video py-4">
                <iframe class='embeded-frame' width="900" height="700" src="https://www.youtube.com/embed/LgWi9Ks-P4I" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
           

        </div>
    )
}

export default CompountWireCutter
